import { Button, Tooltip } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { DownloadIcon } from '@enterprise-ui/icons'

const DownloadItemData = ({ onOpenDownloadModal }) => {
  return (
    <Tooltip content="Download item data" location="top">
      <Button
        type="ghost"
        onClick={onOpenDownloadModal}
        className="button-bg-hover-transparent"
        aria-label="Download item data"
      >
        <EnterpriseIcon
          icon={DownloadIcon}
          size="md"
          className="hc-clr-contrast-weak"
        />
      </Button>
    </Tooltip>
  )
}

export default DownloadItemData
